import { TableCellAlignmentEnum } from './TableCellAlignmentEnum';
import { TableColumn } from './TableColumn';
import { TableColumnOptions } from './TableColumnOptions';
import { TableColumnType } from './TableColumnType';

export class TableColumnIcon extends TableColumn {
  public iconList: (row: any) => string[];
  public icon: (row: any) => string;
  public showIcon?: (row: any) => boolean;
  public iconStyle?: string;
  constructor(
    def: string,
    header: string,
    sortable?: boolean,
    icon?: (row: any) => string,
    showIcon?: (row: any) => boolean,
    iconStyle?: string,
    iconList?: (row: any) => string[],
    width?: number,
    options?: TableColumnOptions,
  ) {
    if (options == null) {
      options = {
        alignment: TableCellAlignmentEnum.CENTER,
        columnType: TableColumnType.Icon,
      };
    }
    super(def, header, (_) => '', sortable, width, options);
    this.icon = icon ?? ((): string => '');
    this.iconList = iconList ?? ((): string[] => []);
    this.showIcon = showIcon ?? ((): boolean => false);
    this.iconStyle = iconStyle ?? '';
  }
}
